export default "__VITE_ASSET__BsqXjvhe__"